import { camelCase } from 'lodash';

import type { Entity } from '../entities';
import type { TrackingContextValue } from '../providers/TrackingContext';

export const getGTMData = (context: Omit<TrackingContextValue, 'category'> = {}) => ({
  widget: context.widget,
  ...context.entities?.reduce(
    (memo, entity) => {
      let key = entity.schema.replace(/iglu:com.starsgroup\/(.*)\/jsonschema\/.*/, '$1');
      key = `${camelCase(key)}s`;
      memo[key] = memo[key] || [];
      memo[key].push(entity.data);
      return memo;
    },
    {} as Record<string, Entity['data'][]>
  )
});
